// src/data/siteContent.js
import Logo from "../images/name_logo2.png";
import Hero from "../images/hero.png";
import Hero1 from "../images/hero1.png";

export const siteMeta = {
  brand: "Dryvziro",
  logo: Logo,
  hero: Hero,
  hero1: Hero1,
  ctaHref: "https://www.gokijany.electrixitaty.com/partnership",
  ctaLabel: "Request Partnership",
};

export const hero = {
  eyebrow: "Transport intelligence for measurable climate action",
  title: "Transforming Transport Emissions into Climate Action",
  subtitle:
    "Dryvziro tracks, quantifies and structures transport emissions across Nairobi so that fuel usage becomes measurable accountability, verified intervention planning and real climate action.",
  stats: [
    { value: "2.1–3.0M", label: "Tonnes CO₂ annually" },
    { value: "650", label: "Tonnes PM2.5" },
    { value: "4x", label: "WHO safe limit" },
  ],
  trust: [
    "Transport operators",
    "Petrol stations",
    "Government",
    "NGOs",
    "Corporates",
  ],
};

export const problemSolution = {
  eyebrow: "Why Dryvziro exists",
  title:
    "Nairobi’s transport emissions are visible in daily life, but they are rarely structured into a system of accountability.",
  intro:
    "Dryvziro closes that gap by turning fragmented transport activity into measurable environmental intelligence and intervention pathways.",
  problem: {
    title: "Urban Air Pollution in Nairobi",
    desc: "Transport emissions produce millions of tonnes of CO₂ and dangerous PM2.5 levels far above WHO limits, yet most operators and institutions still do not work from a shared measurement layer.",
  },
  solutions: [
    {
      title: "Fuel Tracking",
      desc: "Capture fuel usage across Saccos, boda boda ecosystems and fuel stations with structured operational inputs.",
    },
    {
      title: "Emission Mapping",
      desc: "Convert fuel movement into measurable CO₂ and PM2.5 outputs that can be reported, monitored and compared.",
    },
    {
      title: "Climate Action",
      desc: "Trigger verified interventions from real data instead of vague sustainability claims.",
    },
  ],
};

export const howItWorks = {
  eyebrow: "System flow",
  title:
    "A cleaner operational model from raw activity to verified intervention.",
  description:
    "The inspiration site uses premium card storytelling and staggered reveals. This section adapts that exact rhythm for Dryvziro’s system logic.",
  steps: [
    {
      number: "01",
      title: "Data Collection",
      desc: "Fuel usage and mobility data are captured from transport operators, boda boda systems and fuel touchpoints.",
    },
    {
      number: "02",
      title: "Verification Layer",
      desc: "Records are structured into transparent flows so outputs can be verified instead of simply asserted.",
    },
    {
      number: "03",
      title: "Monitoring & Analytics",
      desc: "AI and data logic help track emissions, compare movement patterns and identify where interventions matter most.",
    },
    {
      number: "04",
      title: "Action Triggering",
      desc: "Verified outputs can then support reforestation, fleet efficiency work and cleaner transport programs.",
    },
  ],
};

export const impactData = {
  eyebrow: "Measured outcomes",
  title: "Measurable climate impact, designed to be legible to institutions.",
  description:
    "Dryvziro is not just a visibility layer. It is a decision layer for climate action tied to mobility emissions.",
  headline: [
    { value: "13M", label: "Trees equivalent impact" },
    { value: "2.6M", label: "Tonnes CO₂ reduction" },
    { value: "215K", label: "Vehicles covered" },
  ],
  supporting: [
    { value: "1,850", label: "Jobs created" },
    { value: "175", label: "Communities involved" },
    { value: "1,455", label: "Project duration days" },
    { value: "3,200", label: "Trees planted" },
  ],
};

export const portfolio = {
  eyebrow: "Action portfolio",
  title: "From data to intervention pathways.",
  description:
    "This section mirrors the fleet/gallery block from the reference video, but replaces vehicles with Dryvziro’s intervention portfolio.",
  categories: ["All", "Nature", "Efficiency", "Mobility", "Community"],
  items: [
    {
      title: "Tree Planting",
      desc: "Geotagged and verified reforestation initiatives tied to measurable environmental contribution.",
      tag: "Nature",
    },
    {
      title: "Vehicle Efficiency",
      desc: "Operational improvements that reduce waste, improve fleet behavior and cut emissions over time.",
      tag: "Efficiency",
    },
    {
      title: "Clean Transport",
      desc: "Support for low-emission transport transition pathways and cleaner mobility planning.",
      tag: "Mobility",
    },
    {
      title: "Community Projects",
      desc: "Urban environmental programs focused on high-impact zones and public health relevance.",
      tag: "Community",
    },
    {
      title: "Institutional Reporting",
      desc: "Readable outputs for governments, NGOs and partners who need more than generic climate narratives.",
      tag: "Efficiency",
    },
    {
      title: "Air Quality Visibility",
      desc: "PM2.5 and transport-linked pollution intelligence to help anchor targeted intervention planning.",
      tag: "Mobility",
    },
  ],
};

export const stakeholders = {
  eyebrow: "Who it serves",
  title:
    "Built for institutions that need visibility, action and accountability.",
  items: [
    "Transport Operators",
    "Petrol Stations",
    "Government",
    "NGOs",
    "Corporates",
    "Mobility Programs",
    "Climate Financiers",
    "Urban Planners",
  ],
};

export const technologies = {
  eyebrow: "Technology & transparency",
  title: "The system layer that makes Dryvziro credible.",
  items: [
    {
      title: "Blockchain",
      desc: "Transparent and traceable environmental records that reduce ambiguity and improve trust.",
    },
    {
      title: "AI Monitoring",
      desc: "Real-time emissions tracking and validation logic for more intelligent intervention design.",
    },
    {
      title: "Data Dashboard",
      desc: "Actionable reporting interfaces for institutions, operators and decision-makers.",
    },
  ],
};
